import { ActionTableFilterParamsType } from '../types/table/ActionTableFilterParamsType';
import { FILTER_MODE_CONTAINS, FILTER_MODE_ENDS_WITH, FILTER_MODE_STARTS_WITH } from './constant';

export const handleFilter = <T extends Record<string, string | number>>(
  list: T[],
  filterParams: ActionTableFilterParamsType,
  filterChangeTrigger: boolean,
  setFilteredList: (list: T[]) => void,
  setFilterParams: (filterParams: ActionTableFilterParamsType) => void
) => {
  if (list?.length > 0) {
    const filteredList = list.filter(
      item =>
        filterParams.filterText === '' ||
        filterMatchCheck(
          item[filterParams.filterColumn],
          filterParams.filterText,
          filterParams.filterMode
        )
    );
    setFilteredList(filteredList);
  }

  if (filterChangeTrigger) {
    setFilterParams({
      ...filterParams,
      filterColumn: filterParams.filterColumn,
      filterMode: filterParams.filterMode,
      filterText: filterParams.filterText,
    });
  }
};

function filterMatchCheck(
  targetStr: string | number,
  searchStr: string | number,
  checkType: number
) {
  targetStr = targetStr?.toString().toLowerCase() || '';
  searchStr = searchStr?.toString().toLowerCase() || '';

  let result = false;

  switch (checkType) {
    case FILTER_MODE_CONTAINS:
      result = targetStr?.indexOf(searchStr) >= 0;
      break;
    case FILTER_MODE_STARTS_WITH:
      result = targetStr?.startsWith(searchStr);
      break;
    case FILTER_MODE_ENDS_WITH:
      result = targetStr?.endsWith(searchStr);
      break;
    default:
  }

  return result;
}
